import { P2Button, P2Checkbox, P2TextDescription, P2TextLabel } from 'react-bootstrap-common-script';
import ApplicationCooLayout from '../../../layout/application-coo-layout';
import { Separator } from '../../../components/separator';
import { useNavigate } from 'react-router-dom';
import { SectionCard } from '../../../components/card';
import { Stepper } from '../../../components/stepper';
import { R2stepperItemsStageE } from '../../../utils/shared-dropdown';
import Step2SummarySegment from './segments/summary';
import CpfWithdrawalDetails from './segments/cpf-withdrawal';
import CpfInstalmentPlan from './segments/cpf-instalment';
import { useState } from 'react';
import useViewportWidth from '../../../components/stepper/useViewportWidth';
import { useAppSelector } from '../../../redux/hook';
import { useGetCpfWithdrawalDetailsQuery } from '../../../redux/services/getStageE';
import { PolymerCrypto } from '../../../utils/encryptor';
const activeStep = 2;

function StageERequestUseOfCpf() {
  const isDesktopView = useViewportWidth();
  const navigate = useNavigate();
  const queryParameters = new URLSearchParams(window.location.search);
  const application_id = queryParameters.get('application_id');
  const loginUser = useAppSelector((state) => state.auth.AuthenticationSlice.loginUser);
  const singpassToken = useAppSelector((state) => state.auth.AuthenticationSlice.singpassToken);
  const selectedCpfFormSN = useAppSelector((state) => state.app.ApplicationStageESlice.stage_e_selected_form_sn);
  const selectedCpfFormUUID = useAppSelector((state) => state.app.ApplicationStageESlice.select_cpf_form_uuid);
  const { data: cpfWithdrawalDetails } = useGetCpfWithdrawalDetailsQuery({
    application_id: application_id ?? '',
    uinfin: loginUser.uinfin ?? '',
    singpass_token: singpassToken ?? '',
    request_uuid: selectedCpfFormUUID ?? [],
  });

  // Decrypt CPF account number
  const cpfAccountNumber = PolymerCrypto.decryption(cpfWithdrawalDetails?.nric);

  const [agree, setAgree] = useState<boolean>(false);

  const handleNavigateBack = () => {
    navigate(`/application-coo/stage-e/overview?application_id=${application_id}`);
  };
  const handleProceedNext = () => {
    navigate(`/application-coo/stage-e/home-protection-scheme?application_id=${application_id}`);
  };

  return (
    <ApplicationCooLayout title='Apply to Withdraw CPF Funds Due to Change in Flat Ownership'>
      <div className='polymer-application-coo__wrapper cpf-wrapper'>
        <div>
          <Stepper activeStep={activeStep} items={R2stepperItemsStageE} />
        </div>
        <div className='d-flex flex-column align-items-center gap-3 gap-md-5'>
          <SectionCard
            required={true}
            className='flex-fill'
            activeStep={activeStep}
            stepperItems={R2stepperItemsStageE}
            titleChildren={<P2TextDescription title={R2stepperItemsStageE[activeStep - 1]?.title} />}
            contentChildren={
              <div className='polymer-stage-e'>
                <div className='cpf-container'>
                  <div>
                    <P2TextLabel
                      bold={700}
                      label={'Summary'}
                      fontSize={isDesktopView ? '24px' : '20px'}
                      lineHeight={isDesktopView ? '28px' : '24px'}
                    />
                  </div>

                  <Step2SummarySegment
                    selectedCpfFormSN={selectedCpfFormSN}
                    cpfAccountNumber={cpfAccountNumber}
                    loginUserUinfin={loginUser?.uinfin}
                    applicationId={application_id ?? '0'}
                    singpassToken={singpassToken ?? ''}
                  />
                </div>
                <Separator variant='solid' style={{ margin: '2.5rem 0 1.5rem 0' }} />

                {/* CPF Withdrawal */}
                <CpfWithdrawalDetails cpfWithdrawalDetails={cpfWithdrawalDetails} />
                <Separator variant='solid' style={{ margin: '2.5rem 0 1.5rem 0' }} />

                {/* Use of CPF Savings for Monthly Installments */}
                {cpfWithdrawalDetails?.instalment?.amount_paid_by_cpf > 0 && (
                  <div>
                    <CpfInstalmentPlan cpfWithdrawalDetails={cpfWithdrawalDetails} />

                    <Separator variant='solid' style={{ margin: '0 0 1.5rem 0' }} />
                  </div>
                )}

                {/* Declaration and Authorization */}
                <div className='cpf-container' style={{ gap: '1rem' }}>
                  <div>
                    <P2TextLabel
                      bold={700}
                      label={'Declaration and Authorisation'}
                      fontSize={isDesktopView ? '24px' : '20px'}
                      lineHeight={isDesktopView ? '28px' : '22px'}
                    />
                  </div>
                  <div className='polymer-stage-e_checkbox-wrapper' onClick={() => setAgree((prev) => !prev)} style={{ cursor: 'pointer' }}>
                    <div className='d-flex justify-content-center'>
                      <P2Checkbox variant={'default'} isActive={agree} />
                    </div>
                    <div>
                      <P2TextLabel
                        bold={700}
                        label={'I understand and authorise:'}
                        fontSize={isDesktopView ? '18px' : '16px'}
                        lineHeight={isDesktopView ? '24px' : '22px'}
                      />
                      <ol className='polymer-stage-e_ordered-list-wrapper'>
                        <li>
                          the Housing and Development Board ("HDB") to have access to and obtain from the Central Provident Fund Board (the "Board")
                          any information relating to my Central Provident Fund ("CPF") account for any purpose relating to or in connection with this
                          application.
                        </li>
                        <br />
                        <li>
                          the CPF Board to disclose any information regarding my CPF account to HDB for any purpose relating to or in connection with
                          this application, and to pay the amount applied by me directly to HDB.
                        </li>
                        <br />
                        <li>
                          that the acceptance of the application by the CPF Board does not imply that the CPF Board will approve the withdrawal(s)
                          applied for.
                        </li>
                        <br />
                        <li>
                          that this withdrawal is subject to the provisions of the Central Provident Fund Act (Chapter 36) ("CPF Act") and the
                          subsidiary legislations made thereunder and all such applicable terms and conditions as may be imposed from time to time. I
                          have read, fully understood and agree to comply with and abide by the applicable Terms and Conditions of the CPF Housing
                          Schemes, a copy of which is available at the CPF website.
                        </li>
                        <br />
                        <li>
                          that the amount to be used from my CPF accounts for housing payments for this application will be immediately reserved upon
                          HDB's submission.
                        </li>
                      </ol>
                    </div>
                  </div>
                </div>
              </div>
            }
          />
          {/* Seperator */}
          <div className='cpf-wrapper_seperator'>
            <Separator />
          </div>

          {/* Button Group */}
          <div className='cpf-wrapper_button-wrapper'>
            <div className='cpf-wrapper_button-group'>
              <P2Button onClick={() => handleNavigateBack()} variant={'outline-primary'}>
                Back
              </P2Button>
              <P2Button disabled={!agree} onClick={() => handleProceedNext()} variant={'primary-1'}>
                Continue
              </P2Button>
            </div>
          </div>
        </div>
      </div>
    </ApplicationCooLayout>
  );
}

export default StageERequestUseOfCpf;
